import { Controller } from "@hotwired/stimulus"

// Polls the imei_lookup_status endpoint for MSISDN searches where the ClickHouse
// IMEI lookup runs asynchronously in a background job. Reloads the page once done.
export default class extends Controller {
  static values = { url: String, status: String }

  connect() {
    if (this.statusValue === "pending") {
      this.scheduleNext()
    }
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  scheduleNext() {
    this.timer = setTimeout(() => this.poll(), 10000)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin"
      })

      if (!response.ok) {
        this.scheduleNext()
        return
      }

      const data = await response.json()

      if (data.status === "completed" || data.status === "failed") {
        window.location.reload()
      } else {
        this.scheduleNext()
      }
    } catch (_e) {
      this.scheduleNext()
    }
  }
}
